import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ASSETS } from "../../../../assets/assets";

@Component({
  selector: "app-table-action-button",
  templateUrl: "./table-action-button.component.html",
  styleUrls: ["./table-action-button.component.scss"],
})
export class TableActionButtonComponent {
  iconSrc: string;

  @Input() set icon(name: string) {
    this.iconSrc = ASSETS.icons.find((icon) => icon.name === name)?.path;
  }
  @Input() label: string;
  @Input() variant: "default" | "gold" | "red" | "green" = "default";
  @Input() size: "default" | "lg" = "default";
  @Output() clicked = new EventEmitter<MouseEvent>();
}
